import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Uploads an image file to Firebase Storage and returns the download URL.
 * @param {File} file - The image file to upload.
 * @param {string} path - Folder path inside the storage bucket (default: "blogImages").
 * @returns {Promise<string>} - The public download URL of the uploaded image.
 */
export const uploadImageToStorage = async (file, path = "blogImages") => {
  try {
    const storage = getStorage();
    const timestamp = Date.now();
    const fileRef = ref(storage, `${path}/${timestamp}_${file.name}`);
    const snapshot = await uploadBytes(fileRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    throw error;
  }
};
